"use client"

import React, { useEffect, useState } from "react"
import { Button, Table, message } from "antd"
import { FolderOutlined, FileOutlined } from "@ant-design/icons"
import { getFolders, getFiles, getDownloadLink } from "../functions/requests"
import "./DownloadTable.css"
import { useNavigate } from "react-router"

export const DownloadTable = (props) => {
  const navigate = useNavigate()
  const { token } = props
  const [data, setData] = useState([])
  const [accessToken, setAccessToken] = useState(null)

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text, i) => CustomCell(i),
      width: 1000,
    },
  ]

  // Load Table
  useEffect(() => {
    if (!token) return

    const getInfo = async () => {
      const root = "/"
      const folders = await getFolders(root, token)
      const files = await getFiles(root, token)

      // Return here
      // if (!token) {
      //   navigate("/partners-area/login")
      //   return
      // }
      console.log({ folders, files })

      const children = [
        ...folders.folders.map((folder) =>
          toTreeNode(folder, `${root}${folder.name}`, "folder"),
        ),
        ...files.files.map((file) =>
          toTreeNode(file, `${root}${file.name}`, "file"),
        ),
      ]
      setData(children)
      setAccessToken(token)
    }
    getInfo()
  }, [token])

  const CustomCell = (i) => {
    console.log({ i })
    const nestedLevels = i.key.split("/").length - 2
    let link = null
    if (!i.isFolder) {
      const lastSlash = i.key.lastIndexOf("/")
      const folder = i.key.slice(0, lastSlash)
      const file = i.key.slice(lastSlash + 1)
      link = getDownloadLink(folder, file, accessToken)
    }

    return (
      <div style={{ fontWeight: "bold", paddingLeft: nestedLevels * 20 }}>
        {i.isFolder && <FolderOutlined />}{" "}
        {!i.isFolder && (
          <a href={link} target="_blank" rel="noopener noreferrer">
            <FileOutlined /> {i.name}
          </a>
        )}
        {i.isFolder && i.name}
      </div>
    )
  }

  const toTreeNode = (item, path, type) => ({
    key: path,
    name: item.name,
    isFolder: type === "folder",
    children: type === "folder" ? null : undefined,
  })

  // Recursively inject children into the tree data
  const injectChildren = (nodes, key, children) => {
    return nodes.map((node) => {
      if (node.key === key) {
        return { ...node, children }
      }
      if (node.children) {
        return {
          ...node,
          children: injectChildren(node.children, key, children),
        }
      }
      return node
    })
  }

  const handleExpand = async (record, index) => {
    const folders = await getFolders(`${record.key}`, accessToken)
    const files = await getFiles(`${record.key}`, accessToken)
    const children = [
      ...folders.folders.map((f) =>
        toTreeNode(
          { name: f.name, type: "folder" },
          `${record.key}/${f.name}`,
          "folder",
        ),
      ),
      ...files.files.map((f) =>
        toTreeNode(
          { name: f.name, type: "file" },
          `${record.key}/${f.name}`,
          "file",
        ),
      ),
    ]

    setData((prev) => injectChildren(prev, record.key, children))
  }

  const handleRender = (record) => {
    return <></>
  }

  const handleDownload = (record) => {
    console.log(record)
  }

  const handleLogout = () => {
    localStorage.removeItem("token")
    message.success("You are now signed out of the Partners Area.")
    navigate("/")
  }

  return (
    <>
      <div style={{ margin: "20px", boxSizing: "border-box" }}>
        <div style={{ width: "100%" }}>
          <div style={{ display: "flex", alignItems: "end", gap: "30px" }}>
            <h2>Resources & Downloads</h2>
            <Button onClick={handleLogout}>Sign Out</Button>
          </div>
          <Table
            style={{ width: "100%" }}
            rowKey="name"
            indentSize={25}
            columns={columns}
            dataSource={data}
            pagination={false}
            expandable={{
              rowExpandable: (record) => record.isFolder,
              onExpand: (expanded, record) => handleExpand(record),
              expandedRowRender: (record, index) => handleRender(record, index),
            }}
          />
        </div>
      </div>
    </>
  )
}
